export const itemStates = {
    bidderAuctionRemoved: 'BidderAuctionRemoved',
    bidderBidRemoved: 'BidderBidRemoved',
    bidderEndedWon: 'BidderEndedWon',
    bidderEndedReservedPriceNotReached: 'BidderEndedReservedPriceNotReached',
    bidderEndedNotWon: 'BidderEndedNotWon',
    bidderActiveLeading: 'BidderActiveLeading',
    bidderActiveReservedPriceNotReached: 'BidderActiveReservedPriceNotReached',
    bidderActiveOverbidden: 'BidderActiveOverbidden',
    generalActive: 'GeneralActive',
    generalEnded: 'GeneralEnded',
    purchasedNotPaid: 'PurchasedNotPaid',
    purchasedPaid: 'PurchasedPaid',
    purchasedDone: 'PurchasedDone',
    shopItemActive: 'ShopItemActive',
    shopItemEnded: 'ShopItemEnded',
    shopItemEndedWon: 'ShopItemEndedWon',
    buyItNowEndedWon: 'BuyItNowEndedWon',
    buyItNowEnded: 'BuyItNowEnded',
    buyItNowActive: 'BuyItNowActive',
    sellerActiveBids: 'SellerActiveBids',
    sellerActiveNoBids: 'SellerActiveNoBids',
    sellerReservedPriceNotReached: 'SellerReservedPriceNotReached',
    sellerSoldNotPaid: 'SellerSoldNotPaid',
    sellerSoldDone: 'SellerSoldDone',
    sellerSoldShipped: 'SellerSoldShipped',
    sellerSoldPaid: 'SellerSoldPaid',
    sellerSoldShippingBooked: 'SellerSoldShippingBooked'
};
